/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  BigNumberish,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../../../common";
import type {
  TestERC20,
  TestERC20Interface,
} from "../../../contracts/test/TestERC20";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "initialSupply_",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "decimals_",
        type: "uint8",
      },
      {
        internalType: "bool",
        name: "isFixedCap_",
        type: "bool",
      },
      {
        internalType: "address",
        name: "owner_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "increasedSupply",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "cap",
        type: "uint256",
      },
    ],
    name: "ERC20ExceededCap",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "allowance",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "needed",
        type: "uint256",
      },
    ],
    name: "ERC20InsufficientAllowance",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "needed",
        type: "uint256",
      },
    ],
    name: "ERC20InsufficientBalance",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "approver",
        type: "address",
      },
    ],
    name: "ERC20InvalidApprover",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "cap",
        type: "uint256",
      },
    ],
    name: "ERC20InvalidCap",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "ERC20InvalidReceiver",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "ERC20InvalidSender",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "ERC20InvalidSpender",
    type: "error",
  },
  {
    inputs: [],
    name: "EnforcedPause",
    type: "error",
  },
  {
    inputs: [],
    name: "ExpectedPause",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "OwnableInvalidOwner",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "burnFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "cap",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type TestERC20ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TestERC20ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TestERC20__factory extends ContractFactory {
  constructor(...args: TestERC20ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    name_: string,
    symbol_: string,
    initialSupply_: BigNumberish,
    decimals_: BigNumberish,
    isFixedCap_: boolean,
    owner_: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(
      name_,
      symbol_,
      initialSupply_,
      decimals_,
      isFixedCap_,
      owner_,
      overrides || {}
    );
  }
  override deploy(
    name_: string,
    symbol_: string,
    initialSupply_: BigNumberish,
    decimals_: BigNumberish,
    isFixedCap_: boolean,
    owner_: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(
      name_,
      symbol_,
      initialSupply_,
      decimals_,
      isFixedCap_,
      owner_,
      overrides || {}
    ) as Promise<
      TestERC20 & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): TestERC20__factory {
    return super.connect(runner) as TestERC20__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TestERC20Interface {
    return new Interface(_abi) as TestERC20Interface;
  }
  static connect(address: string, runner?: ContractRunner | null): TestERC20 {
    return new Contract(address, _abi, runner) as unknown as TestERC20;
  }
}
